import React, { Suspense } from "react";
import { ModuleLayoutMockTabs } from "src/framework/layout/ModuleLayoutMockTabs.tsx";

import { ModuleLayoutTabsV2 } from "src/framework/layoutV2/ModuleLayoutTabsV2.tsx";
import { ResolveAuthState } from "src/auth/components/ResolveAuthState/ResolveAuthState.tsx";
import { ModuleLayoutContainer } from "src/framework/layoutV2/ModuleLayoutContainer.tsx";

export type ModuleLayoutV2Props = {
  resource: string;
};

export function ModuleLayoutV2({ resource }: ModuleLayoutV2Props) {
  return (
    <ModuleLayoutContainer>
      <Suspense fallback={<ModuleLayoutMockTabs />}>
        <ResolveAuthState
          LoggedIn={ModuleLayoutTabsV2}
          loggedInProps={{
            resource,
          }}
          Loading={ModuleLayoutMockTabs}
        />
      </Suspense>
    </ModuleLayoutContainer>
  );
}
